import { render, staticRenderFns } from "./FilePageTitle.vue?vue&type=template&id=76dd3ea8&scoped=true"
import script from "./FilePageTitle.vue?vue&type=script&lang=js"
export * from "./FilePageTitle.vue?vue&type=script&lang=js"
import style0 from "./FilePageTitle.vue?vue&type=style&index=0&id=76dd3ea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dd3ea8",
  null
  
)

export default component.exports